module.exports = __webpack_public_path__ + "92f9266d37f2792224bd7f1c1b048c09.png";